import React from "react";
import { Link } from "react-router-dom";
import { Mail, Globe, Twitter, Linkedin } from "lucide-react";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary text-white">
      <div className="container-custom py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-1">
            <Link to="/" className="flex items-center space-x-2">
              <div className="flex items-center"></div>
              <span className="text-xl font-bold">
                WholeFoods<span className="text-accent">.ai</span>
              </span>
            </Link>
            <p className="mt-4 text-gray-300">
              A premium AI domain for food tech, organic markets, and AI-driven
              health solutions.
            </p>
          </div>

          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-gray-300 hover:text-white transition"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="text-gray-300 hover:text-white transition"
                >
                  AI Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-gray-300 hover:text-white transition"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-300 hover:text-white transition"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="#"
                  className="text-gray-300 hover:text-white transition"
                >
                  Domain Value
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-300 hover:text-white transition"
                >
                  AI in Food Tech
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-300 hover:text-white transition"
                >
                  Sustainable Nutrition
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-300 hover:text-white transition"
                >
                  Future of Food
                </a>
              </li>
            </ul>
          </div>

          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-2">
              <li className="flex items-center">
                <Mail className="h-5 w-5 mr-2 text-accent" />
                <a
                  href="mailto:info@wholefoods.ai"
                  className="text-gray-300 hover:text-white transition"
                >
                  info@wholefoods.ai
                </a>
              </li>
              <li className="flex items-center">
                <Globe className="h-5 w-5 mr-2 text-accent" />
                <a
                  href="https://wholefoods.ai"
                  className="text-gray-300 hover:text-white transition"
                >
                  wholefoods.ai
                </a>
              </li>
            </ul>
            <div className="mt-4 flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-white transition">
                <Twitter className="h-6 w-6" />
              </a>
              <a
                href="https://www.linkedin.com/in/merlup/"
                className="text-gray-300 hover:text-white transition"
              >
                <Linkedin className="h-6 w-6" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-700 text-center text-gray-400">
          <p>&copy; {currentYear} WholeFoods.ai. All rights reserved.</p>
          <p className="mt-2 text-sm">
            This is a domain for sale. Not affiliated with Whole Foods Market,
            Inc.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
